<template>
  <div class="person-detail-content" v-if="person">
    <div class="person-header">
      <img v-if="person.photo" :src="person.photo" alt="Photo" class="person-photo" />
      <div class="person-info">
        <h1>{{ person.name }}</h1>
        <p v-if="person.phone"><strong>手机号:</strong> {{ person.phone }}</p>
        <p v-if="person.email"><strong>邮箱:</strong> {{ person.email }}</p>
        <p v-if="person.else"><strong>{{ person.else }}</strong></p>
        <p v-if="person.education"><strong>学历:</strong> {{ person.education }}</p>
        <p v-if="person.link"><strong>相关链接:</strong> <a :href="person.link" target="_blank">{{ person.link }}</a></p>
      </div>
    </div>

    <div class="person-body">
      <h2>个人简历</h2>
      <p v-if="person.resume" style="text-indent: 2em;">{{ person.resume }}</p>

      <h2>学术研究</h2>
      <p v-if="person.research">{{ person.research }}</p>

      <h2 v-if="person.educationBackground">教育背景</h2>
      <p v-if="person.educationBackground">{{ person.educationBackground }}</p>

      <h2 v-if="person.social">社会任职</h2>
      <p v-if="person.social">{{ person.social }}</p>

      <h2 v-if="person.publications">发表刊物</h2>
      <p v-if="person.publications">{{ person.publications }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonDetailView",
  props: ["id"],
  data() {
    return {
      person: null
    };
  },
  mounted() {
    this.fetchPersonData();
  },
  methods: {
    async fetchPersonData() {
      try {
        const response = await fetch("/peopledetail.json");
        const data = await response.json();
        this.person = data[this.id];
      } catch (error) {
        console.error("获取人员数据失败:", error);
      }
    }
  }
};
</script>
<style scoped>
.person-detail-content {
 margin: 1.25rem;
}

.person-header {
 display: flex;
 align-items: center;
}

.person-photo {
 width: 9.375rem;
 margin-right: 1.25rem;
}

.person-info h1 {
 margin: 0;
 font-size: 1.5rem;
 font-weight: bold;
}

.person-info p {
 margin: 0.3125rem 0;
}

.person-body h2 {
 font-size: 1.25rem;
 margin-top: 1.875rem;
 font-weight: bold;
}

.person-body ul {
 list-style-type: none;
 padding-left: 0;
}

.person-body li {
 margin: 0.3125rem 0;
}
</style>
